"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _user = _interopRequireDefault(require("hub-http-shims/UserDataJS/user"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _BaseEmailConfirmBarLoader = _interopRequireDefault(require("../lib/BaseEmailConfirmBarLoader"));

var _EmailVerificationEndpoints = require("../constants/EmailVerificationEndpoints");

var _defer = _interopRequireDefault(require("q/js/lib/defer"));

var HapiJSPrebuilt =
/*#__PURE__*/
function (_BaseEmailConfirmBarL) {
  (0, _inherits2.default)(HapiJSPrebuilt, _BaseEmailConfirmBarL);

  function HapiJSPrebuilt() {
    (0, _classCallCheck2.default)(this, HapiJSPrebuilt);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(HapiJSPrebuilt).apply(this, arguments));
  }

  (0, _createClass2.default)(HapiJSPrebuilt, [{
    key: "getRequiredData",
    value: function getRequiredData() {
      var deferred = (0, _defer.default)();

      _user.default.then(function (user) {
        deferred.resolve({
          email: user.get('email'),
          isVerified: !!(user.get('verified') || user.get('verifiedAt')),
          userId: user.id // not immutable

        });
      });

      return deferred.promise;
    }
  }, {
    key: "handleResend",
    value: function handleResend(id) {
      return _apiClient.default.post((0, _EmailVerificationEndpoints.getEmailVerificationEndpoint)(id));
    }
  }]);
  return HapiJSPrebuilt;
}(_BaseEmailConfirmBarLoader.default);

var _default = HapiJSPrebuilt;
exports.default = _default;
module.exports = exports.default;